import { AssistantSuggestion, AssistantSuggestionType } from '@mews-commander/data-access';
import { List } from '@optimus-web/core/src/List';
import { ListHeadline, ListItem, Typography } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { highlight, HighlightVariant } from '../../utils/highlight';
import { scrollListItemIntoView } from '../../utils/resultListItemUtil';

const getSuggestionIndex = (suggestion: AssistantSuggestion, suggestions: AssistantSuggestion[]): number =>
    suggestions.indexOf(suggestion);

interface SuggestionsProps {
    titleTextKey: Mews.TextKey;
    suggestions: AssistantSuggestion[];
    allSuggestions: AssistantSuggestion[];
    searchTerm: string;
    selectedIndex: number;
    handleClick: (suggestion: AssistantSuggestion) => void;
}

export const Suggestions = ({
    titleTextKey,
    suggestions,
    allSuggestions,
    searchTerm,
    selectedIndex,
    handleClick,
}: SuggestionsProps) => (
    <List>
        {suggestions?.length > 0 ? (
            <ListHeadline>
                <Typography textStyle="bodyMedium" variant="tertiary" as="div">
                    <LocalizedText textKey={titleTextKey} />
                </Typography>
            </ListHeadline>
        ) : null}
        {suggestions?.map((suggestion) => {
            const isSelected = getSuggestionIndex(suggestion, allSuggestions) === selectedIndex;
            return (
                <ListItem
                    dense
                    key={suggestion.type + suggestion.text + suggestion.description}
                    onClick={() => handleClick(suggestion)}
                    selected={isSelected}
                    primaryText={highlight(suggestion.text, searchTerm, HighlightVariant.keyword)}
                    secondaryText={
                        suggestion.type !== AssistantSuggestionType.Command ? suggestion.description : undefined
                    }
                    innerRef={(e) => scrollListItemIntoView(e, isSelected)}
                />
            );
        })}
    </List>
);
